/**
 * Persists in-progress auth journeys in localStorage so that a page reload
 * (e.g. iOS Safari killing the tab while the user fetches a code from their
 * e-mail app) lands the user back on the same step with the e-mail filled in.
 *
 * Nothing sensitive is stored here — only the e-mail and timestamps.
 */

const KEYS = {
  confirmation: "acig.auth.pendingConfirmation",
  reset: "acig.auth.pendingReset",
};

const read = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const write = (key, value) => {
  try {
    if (value) localStorage.setItem(key, JSON.stringify(value));
    else localStorage.removeItem(key);
  } catch {
    /* storage unavailable (private mode quota) — journey still works, just without resume */
  }
};

export const getPendingConfirmation = () => read(KEYS.confirmation);
export const setPendingConfirmation = (email) =>
  write(KEYS.confirmation, email ? { email, requestedAt: Date.now() } : null);
export const clearPendingConfirmation = () => write(KEYS.confirmation, null);

export const getPendingReset = () => read(KEYS.reset);
export const setPendingReset = (email) =>
  write(KEYS.reset, email ? { email, requestedAt: Date.now() } : null);
export const clearPendingReset = () => write(KEYS.reset, null);
